import React from 'react';
import PrintText from './PrintText';
import { Field } from 'redux-form/immutable';
import { renderField, convertToFloat } from './_FORM_FIELDS';
import { onUIAction } from '../../utils/uiActions';

const Decimal = props => {
  const { classProperty, type, validations, value, isReadOne, ...rest } = props;
  const workflow = props.workflow;
  return (
    <div>
      {isReadOne ? (
        <PrintText {...props} />
      ) : (
        <Field
          name={classProperty}
          component={renderField}
          type='number'
          step={"any"}
          validate={props.disableLayoutItem ? [] : validations}
          value={value}
          fieldType={type}
          {...rest}
          _onBlur={(formValues, target, currentValue) => {
              const uia = workflow && workflow.currentItem.layoutProperties.uiActions;
              onUIAction(
                formValues,
                props.dispatch,
                uia,
                props.change,
                target,
                currentValue
              );
            }}
          normalize={convertToFloat}
          disabled={props.disableLayoutItem || props.disableState}
        />
      )}
    </div>
  );
};

export default Decimal;
